<template>
  <b-modal id="localProductDeleteModal" ref="localProductDeleteModal" @show="getLicenseCount" no-stacking @hidden="resetModal">
    <template slot="modal-title">{{ $t('deleteLocalProduct') }}</template>

    <template v-if="isProductLicensesFound">
      {{ licenseCount }} {{ $t('localProductDeleteMessageIfLicensesFound') }}
    </template>
    <template v-else>
      {{ $t('localProductDeleteMessageIfNoLicensesFound') }}
    </template>
    <p>{{ $t('localProductDeleteConfirm') }}</p>

    <div slot="modal-footer" class="col-md-12">
      <b-button variant="primary" class="float-lg-right" @click="deleteLocalProduct">{{ $t('delete') }}</b-button>
      <b-button variant="secondary" class="float-lg-left" @click="cancel">{{ $t('cancel') }}</b-button>
    </div>
  </b-modal>
</template>

<script>
  import { mapGetters } from 'vuex'
  import LicenseService from '../../services/LicenseService'
  import ProductService from '../../services/ProductService'

  export default {
    name: 'LocalProductDeleteModal',
    data() {
      return {
        licenses: [],
        licenseCount: null,
      }
    },
    computed: {
      ...mapGetters('products', ['product']),
      isProductLicensesFound () {
        return (this.licenseCount > 0)
      }
    },
    methods: {
      cancel() {
        this.$bvModal.hide('localProductDeleteModal')
      },
      async deleteLocalProduct() {
        const ids = this.licenses.map(license => license.licenseId)
        if (ids.length > 0) {
          await LicenseService.deleteLicenseByLicenseIds(ids)
        }

        ProductService.deleteLocalProduct(this.product.ean)
          .then(() => {
            this.$router.go(-1)
          })
      },
      resetModal() {
        this.ean = ''
        this.licenses = []
        this.licenseCount = null
      },
      async getLicenseCount () {
        let response = await LicenseService.getLicensesByEan(this.product.ean)
        this.licenses = response.response
        this.licenseCount = response.resultCount
      }
    },
    i18n: {
      messages: {
        en: {
          "deleteLocalProduct": "Delete local product",
          'localProductDeleteMessageIfLicensesFound' : 'licenses were found for this product. If you delete the products, all the licenses will also be deleted.',
          'localProductDeleteMessageIfNoLicensesFound' : 'No licenses for this product was found.',
          'localProductDeleteConfirm' : 'Do you want to continue?'
        },
        nb: {
          'deleteLocalProduct': 'Slett lokalt produkt',
          'localProductDeleteMessageIfLicensesFound' : 'lisenser for dette produktet ble funnet. Dersom du sletter produktet, vil også disse lisensene bli slettet.',
          'localProductDeleteMessageIfNoLicensesFound': 'Ingen lisenser for dette produktet ble funnet.',
          'localProductDeleteConfirm' : 'Vil du fortsette?'
        }
      }
    }
  }
</script>